import { useCallback, useState } from 'react';
export function useToggle(initialState = false) {
    const [state, setState] = useState(initialState);
    const setTrueState = useCallback(() => setState(true), []);
    const setFalseState = useCallback(() => setState(false), []);
    const toggle = useCallback(() => setState((currentState) => !currentState), []);
    return [state, setTrueState, setFalseState, toggle];
}
